<section class="tender-proposal-panel">
  <pwj-tender-countdown-timer
    [finishDate]="tender()?.finish_time"
    [startDate]="tender()?.start_time"></pwj-tender-countdown-timer>

  <div class="tender-proposal-panel__sheet">
    <div class="tender-proposal-panel__tabs-wrap">
      <ul class="tender-proposal-panel__tabs">
        @for (tab of tabs; track tab.tabTitle) {
          <li
            class="tender-proposal-panel__tab"
            [class.tender-proposal-panel__tab--active]="
              activeTab() === tab.tabTitle
            "
            (click)="onSelectTab(tab.tabTitle)">
            {{ getTabLabel(tab.tabTitle) | translate }}
          </li>
        }
      </ul>
    </div>

    <div class="tender-proposal-panel__content">
      @switch (activeTab()) {
        @case ('submit-quote') {
          <pwj-tender-submit-quote-tab
            [tender]="tender()"
            [isActive]="isActive()"
            [isUserLoggedIn]="isUserLoggedIn"
            (submitQuote)="submitQuote.emit()"></pwj-tender-submit-quote-tab>
        }
        @case ('delivery-address') {
          <pwj-tender-delivery-tab [tender]="tender()"></pwj-tender-delivery-tab>
        }
      }
    </div>
  </div>
</section>
